import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetImporter  {
    _originalTypeClassName = "zERP.BO.AssetImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetImporter.translate = translateService;
}
this.AssetImporterKey = null;
this._key = this.AssetImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AssetImporterKey:any;
get AssetImporterKey(): any {
    return this._AssetImporterKey;
  }
set AssetImporterKey(value: any) {
    this._AssetImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetImporterKey == null || $this.AssetImporterKey == 0;
            }


}